<template>
  <div class="message-wrapper">
    <div class="title">
      <p class="title-content">{{ message }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

const Message = defineComponent({
  props: {
    type: {
      type: String,
      default: 'Success'
    },
    message: {
      type: String,
      default: ''
    }
  }
})
export default Message
</script>

<style lang="less">
.message-wrapper {
  height: auto;
  width: auto;
  // sum max width = 560, including default width of other elements
  max-width: 450px;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  // justify-content: center;
  text-align: left;
  .title{
    margin-left: 16px;
  }
  .title-content {
    margin-bottom: 0;
  }
}

.ant-message-custom-content{
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 24px;
  min-height: 62px;
}

@media only screen and (max-width: 992px) {
  // 控制宽度
  .ant-message-notice-content {
    max-width: calc(100vw - 3rem);
  }
}
</style>
